import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery';
import { connect } from 'react-redux';
import { caseSetServerError } from './../../actions/caseActions';
import { userTourDone } from './../../actions/userActions';

const STEPS = {
    case: [
    {
        intro: 'This is a case detail page.',
    },
    {
        element: '#tour-case-state',
        intro: 'Set the case state here and move it along your pipeline.',
    },
    {
        element: '#tour-case-info',
        intro: 'Information about your case.',
    },
    {
        element: '#tour-case-info-client',
        intro: 'Client information.',
    },
    {
        element: '#tour-case-info-fee',
        intro: 'How much does the client owe you.',
    },
    {
        element: '#tour-case-info-paid',
        intro: 'How much has the client already paid.',
    },
    {
        element: '#tour-case-info-time',
        intro: 'How much time have you spent on this case.',
    },
    {
        element: '#tour-case-info-form',
        intro: 'This is case intake form. You can change what is visible Configuration -> Case Forms.',
    },
    {
        element: '#tour-case-info-sms',
        intro: 'Send SMS text message (based on sms templates).',
    },
    {
        element: '#tour-case-info-email',
        intro: 'Send email (based on email templates and attach autofilled documents).',
    },
    {
        element: '#tour-case-info-fax',
        intro: 'Send faxes (from autofilled documents).',
    },
    {
        element: '#tour-case-info-edit',
        intro: 'Edit this case intake form.',
    },
    {
        element: '#tour-case-info-archive',
        intro: 'Archive (or permanently delete) this case once you are done with the case.',
    },
    {
        element: '#tour-case-events',
        intro: 'Chronologically listed case events (signing, faxing, emailing, payment,...).',
    },
    {
        element: '#tour-case-events-filter',
        intro: 'Filter events that you see.',
    },
    {
        element: '#tour-case-action-task',
        intro: 'Create new tasks manually here. It is possible to have tasks precreated as well for each case type (Configure -> Tasks).',
    },
    {
        element: '#tour-case-action-task-label',
        intro: 'Name your task. This will be always visible.',
    },
    {
        element: '#tour-case-action-task-date',
        intro: 'Task date (syncs with your calendar): <ul><li class="bullet">Write as a text when its due, eg. "tomorrow", "in 5 hours", "in a week", "friday at 5pm"</li><li class="bullet">Specify meetings, eg. "next tuesday at 5pm - 7pm".</li><li class="bullet">Write date/time directly, eg. "5/6/2018 3:30pm"</li></ul>',
    },
    {
        element: '#tour-case-action-task-date-btn',
        intro: 'Show a calendar to pick a date.',
    },
    {
        element: '#tour-case-action-task-description',
        intro: 'Add more detailed description if necessary.',
    },
    {
        element: '#tour-case-action-task-blockedby',
        intro: 'Select a task that will make this task hidden, until the task it is blocked by gets completed or deleted.',
    },
    {
        element: '#tour-case-action-task-action',
        intro: 'Set automatic action (sending email, changing case state) upon task completion.',
    },
    {
        element: '#tour-case-action-task-add',
        intro: 'Add the task.',
    },
    {
        element: '#tour-case-tasks',
        intro: 'See all tasks for this case.',
    },
    {
        element: '#tour-case-tasks-filter',
        intro: 'Filter tasks you want to see (eg. view completed tasks).',
    },
    {
        element: '#tour-tasks',
        intro: 'See all the tasks here, complete them and edit them.',
    },
    {
        element: '#tour-case-action-event',
        intro: 'Add events manually (notes, payments, client contacted).',
    },
    {
        element: '#tour-case-action-payment',
        intro: 'Create a client payment portal that you can then email client for signing your agreement and paying online. Or type in client\'s credit card manually over the phone.',
    },
    {
        element: '#tour-case-action-documents',
        intro: 'Upload/download your Microsoft Word templates containing placeholders from Help -> Template Placeholders. You can use these documents for sending emails, faxing or just create autofilled PDFs that you can print.',
    },
    {
        element: '#tour-case-action-scratchpad',
        intro: 'Notepad area for your lengthier notes.',
    },
    {
        element: '#tour-case-tab',
        intro: 'You can come back to this case by clicking this tab.',
    },
    {
        element: '#tour-case-close',
        intro: 'Close the case detail tab and return to dashboard tab.',
    },
    ],
    cases: [
    {
        intro: 'This is your dashboard. It has a searchable database of all your cases, tasks you need to do and your case pipeline.',
    },
    {
        element: '#tour-menu-dashboard',
        intro: 'Click the dashboard tab at any time to get to this page.',
    },
    {
        element: '#tour-menu-reports',
        intro: 'Reports tab - your business analytics. Find how much you are making, could be making, etc.',
    },
    {
        element: '#tour-menu-contacts',
        intro: 'Contacts tab. Database of all your clients and other types of contacts you defined and are using in your practice.',
    },
    {
        element: '#tour-menu-configure',
        intro: 'Configure menu. Here you can configure: <ul><li class="bullet">Case and Contact Forms.</li><li class="bullet">Case States.</li><li class="bullet">Tasks (preset tasks that you need to do every time for a given case here).</li><li class="bullet">Templates (document, email, sms).</li></ul>',
    },
    {
        element: '#tour-menu-help',
        intro: 'Help menu. <ul><li class="bullet">Launch help tours like this one.</li><li class="bullet">Send us feedback/message.</li><li class="bullet">See all <b>placeholders</b> you can use for creating templates.</li></ul>',
    },
    {
        element: '#tour-menu-account',
        intro: 'Account menu.<ul><li class="bullet">Update your profile.</li><li class="bullet">Add signature to your emails.<li class="bullet"> Add other employees.</li><li class="bullet">Enable 2FA authentication.</li><li class="bullet">Also this is where you can log out.</li?</ul>',
    },
    {
        element: '#tour-case-states',
        intro: 'Case states. Think of it as pipeline that your cases go through from start to finish.',
    },
    {
        element: '#tour-case-states-details',
        intro: 'Name of a given case state and number of cases in this case state.',
    },
    {
        element: '#tour-case-states-goto',
        intro: 'This link will show you just cases for given case state.',
    },
    {
        element: '#tour-cases-table',
        intro: 'Database of all your cases.',
    },
    {
        element: '#tour-new-case',
        intro: 'Create a new case.',
    },
    {
        element: '#tour-cases-search',
        intro: 'Google like search box to find your cases. Search is performed only among visible columns.',
    },
    {
        element: '#tour-cases-search-advanced',
        intro: 'Advanced search. You can create as save advanced search queries, such as "show me cases where I haven\'t got paid yet", "show me all cases of certain types closed last week", etc.',
    },
    {
        element: '#tour-cases-table .rt-thead',
        intro: '<ul><li class="bullet">Click <span class="glyphicon glyphicon-cog"></span>&nbsp; to open dialog where you can choose what columns you want to see.</li><li class="bullet">Click any column to sort the rows.</li><li class="bullet">Click multiple columns while holding SHIFT to sort by multiple columns.</li><li class="bullet">Drag and drop line in between columns to resize the table.</li></ul>',
    },
    {
        element: '#tour-cases-table .rt-tbody',
        intro: 'Click any case to open it.',
    },
    {
        element: '#tour-tasks',
        intro: 'Tasks.<ul><li class="bullet"></li><li class="bullet">Meetings, deadlines, daily tasks.</li><li class="bullet">All tasks with date/time are also synchronized with your calendar.</li></ul>',
    },
    {
        element: '#tour-tasks-filter',
        intro: 'Filter what tasks you want to see!',
    }],
};


class Tour extends PureComponent {
    constructor(props) {
        super(props);
        this.onScriptLoaded = this.onScriptLoaded.bind(this);
        this.loadScript = this.loadScript.bind(this);
        this.onError = this.onError.bind(this);
        this.init = this.init.bind(this);
        this.exitClean = this.exitClean.bind(this);
        this.state = {
            scriptLoading: false,
            scriptLoaded: false,
            scriptDidError: false,
        };
    }

    componentWillReceiveProps(nextProps) {
        this.loadScript();
        this.exitClean();
        this.init(nextProps);
    }

    componentDidMount() {
        this.loadScript();
        this.init(this.props);
    }

    componentWillUnmount() {
        if (this.loadPromise) {
            this.loadPromise.cancel();
        }

        this.exitClean();
    }

    exitClean() {
        if (this.intro) {
            this.intro.onexit(() => {});
            this.intro.oncomplete(() => {});
            this.intro.exit();
            this.tourStarted = false;
        }
    }

    onScriptLoaded() {
        this.init(this.props);
    }

    onError(error) {
        if (error.isCanceled) {
            return;
        }

        if (this.props.onError) {
            this.props.onError(error);
        }
        else {
            console.error('Cannot start tour: ' + JSON.stringify(error));
            this.props.dispatch(caseSetServerError('Cannot start tour! ' + JSON.stringify(error)));
        }
    }

    init(props) {
        if (!__CLIENT__ || typeof window.introJs === 'undefined') {
            return;
        }

        if (!props.loggedIn) {
            return;
        }

        if (this.tourStarted) {
            return;
        }

        if (STEPS[props.selectedTab]) {
            if (!this.onAvailableCalled) {
                this.onAvailableCalled = true;
                props.onAvailable(Object.keys(STEPS));                
            }
        } else {
            return;
        }

        if (props.loggedIn[props.selectedTab + "TourDone"] && !props.run) {
            return;
        }

        // An admin viewing another user's account may launch a tour from the Help menu, but tours never
        // start by themselves there and are not recorded as done for that user.
        if (props.impersonating && !props.run) {
            return;
        }

        this.tourStarted = true;
        const intro = window.introJs();
        const completed = () => {
            if (!props.impersonating) {
                props.dispatch(userTourDone(props.selectedTab + "TourDone"));
            }

            props.onDone();
            this.tourStarted = false;
        };

        intro.onexit(completed);
        intro.oncomplete(completed);

        let steps = [...STEPS[props.selectedTab]]
        steps = steps.filter(step => !step.element || (step.element && $(step.element).length > 0));
        intro.setOptions({
            steps,
            showStepNumbers: false,
            showBullets: false,
            showProgress: true,
        });

        this.intro = intro;
        intro.start();
    }

    loadScript() {
        if (this.state.scriptLoaded || this.state.scriptLoading) {
          return;
        }

        this.setState({scriptLoading: true});
        const script = document.createElement('script');
        if (typeof this.props.onScriptTagCreated === 'function') {
              this.props.onScriptTagCreated(script);
        }

        script.src = '/js/intro.min.js';
        script.async = 1;
        this.loadPromise = (() => {
            let canceled = false;
            const promise = new Promise((resolve, reject) => {
                script.onload = () => {
                    this.setState({scriptLoaded: true});
                    this.setState({scriptLoading: false});
                    resolve();
                    this.onScriptLoaded();
                };

                script.onerror = (event) => {
                    this.setState({scriptDidError: true});
                    this.setState({scriptLoading: false});
                    reject(event);
                    this.onError('Tour service is not responding.');
                };
            });

            const wrappedPromise = new Promise((accept, cancel) => {
                promise.then(() => canceled ? cancel({ isCanceled: true }) : accept()); // eslint-disable-line no-confusing-arrow
                promise.catch(error => canceled ? cancel({ isCanceled: true }) : cancel(error)); // eslint-disable-line no-confusing-arrow
            });

            return {
                promise: wrappedPromise,
                cancel() { canceled = true; }
            };
        })();

        this.loadPromise.promise
          .then(this.onScriptLoaded)
          .catch(this.onError);

        document.body.appendChild(script);
    }
 
    render() {
        return <div />;
    }
}

Tour.propTypes = {
    loggedIn: PropTypes.object.isRequired,
    selectedTab: PropTypes.string.isRequired,
    run: PropTypes.bool,
    impersonating: PropTypes.bool,
    onDone: PropTypes.func.isRequired,
    onAvailable: PropTypes.func.isRequired,
    onError: PropTypes.func,

    // Runs when the script tag is created, but before it is added to the DOM
    onScriptTagCreated: PropTypes.func,
};

export default connect()(Tour);
